module.exports = __webpack_public_path__ + "img/Carousel-funcionalidades-icono-04.6af449f7.svg";